import ProvidersListView from 'views/ProvidersManagement/ProvidersListView';

const ProvidersRouters = [
  {
    path: 'providers-list',
    element: <ProvidersListView />
  }
];

export default ProvidersRouters;
